const DEFAULT_IMAGE = "/static/main-page-banner.jpg";

/**
 * The banner every marketing page opens with. The photo fades into the page
 * background (see .cx-hero in ui.scss), so pages can start their first section
 * right underneath without a visible seam.
 */
const PageHero = ({eyebrow, title, accent, subtitle, image = DEFAULT_IMAGE}) => (
    <section className="cx-hero" style={{"--cx-hero-image": `url('${image}')`}}>
        <div className="container">
            {eyebrow && <span className="cx-hero-eyebrow">{eyebrow}</span>}
            <h1 className="cx-hero-title">
                {title}{accent && <> <span>{accent}</span></>}
            </h1>
            {subtitle && <p className="cx-hero-subtitle">{subtitle}</p>}
        </div>
    </section>
);

export default PageHero;
